import { useSelector } from 'react-redux'

export function useObjSelector(callback) {
  const selector = useSelector((state) => JSON.stringify(callback(state)))
  // JSON.parse(undefined) causa erro, JSON.parse(null) retorna null
  return JSON.parse(selector || null)
}
